import React from "react"
import { graphql } from "gatsby"

import RevitalizeVideos from "components/revitalize-videos"

const RevitalizeVideosPage = ({ data: { allVideo, video } }) => (
  <RevitalizeVideos videos={allVideo.nodes} selectedVideo={video} />
)

export default RevitalizeVideosPage

export const query = graphql`
  query ($url: String) {
    allVideo {
      nodes {
        active
        airDate
        description
        id
        image
        lengthInSeconds
        metaDescription
        speakers
        tags
        title
        url
        videoId
      }
    }

    video(url: { eq: $url }) {
      active
      airDate
      description
      id
      image
      lengthInSeconds
      metaDescription
      speakers
      tags
      title
      url
      videoId
      videoSignature
    }
  }
`
